import CrossProjectGapModel from "./crossProjectGapModel";
import CrossProjectGapsResult from "./crossProjectGapsResult";

export {
  CrossProjectGapModel,
  CrossProjectGapsResult,
};
